/*	MARK: Samantia | Archive
	============================================
 */
/** Imports **/
import { inject, PLATFORM } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request } from '../services/data-service';
import { Api } from '../services/api';

@inject(DataService, Api, Router)
export class MachineArchive {
	/** MARK: Components methods
		=================================
	 **/
	constructor(ds, api, router){
		// Services
		this.ds		= ds;
		this.api	= api;
		this.router = router;

		this.filter_tags = {
			"Forecast"	: { "active":false },
			"Simulation": { "active":false },
			"Quick"		: { "active":false },
			"Bulk"		: { "active":false }
		}
	}

	activate(params){ this.id = params.id } // MachineID


	attached(){
		/*	============================================
		  	1 Get machine from dataservice
			2 Get dataset from machine.dataset(split name)
			3 Setup machine and dataset to DataService
			============================================
		*/
		window.setTimeout( () => {this.init();}, 300);
	}
	init(){
		/*	============================================
		  	1 Get machine from dataservice
			2 If machine existis, procede to get dataset
			  else -> get remote machine and dataset
			3 Setup machine and dataset to DataService
			============================================
		*/
		let machine = this.ds.app_data.machine;
		if(!machine){
			// Get remote machine data
			this.getMachine(this.id).then(response => {
				//this.handleMachineResponse(response);
				return this.handleMachineResponse(response);
				// Get dataset?
				
			})
			.then(handled => {
				return this.getPredictions(this.machine._id);
			})
			.then(res => {
				return this.handlePredictionsResponse(res);
				
			});

		}
		else{
			this.machine = machine;
			this.ds.app_data.machine = machine;
			this.getPredictions(this.machine._id).then(response => {
				this.handlePredictionsResponse(response);
			});
			
		}
		
	}

	/** API Calls
		============================================
	**/

	getMachine(id){
		// Request
		let request 	= new Request("/api/v2/machines/id?", "GET");
		let params  	= new URLSearchParams({ id:id });
		request.url 	= request.url + params;
		// Perform remote call
		return this.api.get(request);
	}

	handleMachineResponse(response){
		let status = response.status;
		if(status === 200){
			let machine  = response.data;
			machine.features = machine.features
			this.machine = machine
			this.ds.app_data.machine = machine;
		};
	}

	/**  Get predictions **/
	getPredictions(id){
		// Request
		let request 	= new Request("/api/v2/machines/"+id+"/predictions/", "GET");

		return this.api.get(request);
	}

	handlePredictionsResponse(response){
		let status = response.status;
		if(status === 200 ){
			let data = response.data;
			//let archive 	= Object.groupBy(data, ({credentials}) => credentials.type );
			this.archive 	= data;
			// Apply filter
			//if(this.machine.algorithm != "serie"){ this.apply_filter("Simulation");}
			//else{this.apply_filter("Forecast");}

			if( (this.machine.algorithm != "serie") && (this.machine.algorithm != "multivar_serie") ){
				this.apply_filter("Simulation");
			}
			else{this.apply_filter("Forecast");}
			
		}
	}

	displayDate(date){
		let d = new Date(date);
		return d.toDateString();
	}

	filterPredictionsByTags(predictions, tags){
		// prediction 	-> array of predictions
		// tags			-> array of tags (Quic, Simulation, Bulk)
		let results = [];
		tags.forEach(tag => {
			let buffer_res = predictions.filter( pred => pred.credentials.type === tag);
			results = results.concat(buffer_res);
		});
		return results
	}
	
	apply_filter(tag){
		// Toogle filter
		this.filter_tags[tag].active = !this.filter_tags[tag].active;
		let tags 	= []
		Object.keys(this.filter_tags).forEach(tag => {
			if(this.filter_tags[tag].active === true){ tags.push(tag);}
		});
		this.filtered_archive = this.filterPredictionsByTags(this.archive, tags)
	}
	/** Actions
		============================================
	**/
}
